import type { AppLocale } from '@/i18n/locales';

/** Curated shortcuts shown above the full list (matches common regional defaults). */
export const SUGGESTED_LOCALES: readonly AppLocale[] = ['ar-SA', 'en-US'];

export const SUGGESTED_LOCALE_SET = new Set<AppLocale>(SUGGESTED_LOCALES);

/** Native-language primary line + English region line for chip UI. */
export const LOCALE_CHIP_LABELS = {
  ar: { native: 'العربية', region: 'Arabic' },
  'ar-SA': { native: 'العربية', region: 'Saudi Arabia' },
  'bg-BG': { native: 'Български', region: 'Bulgaria' },
  'cs-CZ': { native: 'Čeština', region: 'Czechia' },
  'da-DK': { native: 'Dansk', region: 'Denmark' },
  'de-DE': { native: 'Deutsch', region: 'Germany' },
  'el-GR': { native: 'Ελληνικά', region: 'Greece' },
  en: { native: 'English', region: 'United Kingdom' },
  'en-US': { native: 'English', region: 'United States' },
  'es-MX': { native: 'Español', region: 'Mexico' },
  'fi-FI': { native: 'Suomi', region: 'Finland' },
  'fr-FR': { native: 'Français', region: 'France' },
  'hr-HR': { native: 'Hrvatski', region: 'Croatia' },
  'hu-HU': { native: 'Magyar', region: 'Hungary' },
  'id-ID': { native: 'Bahasa Indonesia', region: 'Indonesia' },
  'it-IT': { native: 'Italiano', region: 'Italy' },
  'ja-JP': { native: '日本語', region: 'Japan' },
  'ko-KR': { native: '한국어', region: 'Korea' },
  'lt-LT': { native: 'Lietuvių', region: 'Lithuania' },
  'ms-MY': { native: 'Melayu', region: 'Malaysia' },
  'nb-NO': { native: 'Norsk bokmål', region: 'Norway' },
  'nl-NL': { native: 'Nederlands', region: 'Netherlands' },
  'pl-PL': { native: 'Polski', region: 'Poland' },
  'pt-BR': { native: 'Português', region: 'Brazil' },
  'ro-RO': { native: 'Română', region: 'Romania' },
  'ru-RU': { native: 'Русский', region: 'Russia' },
  'sl-SI': { native: 'Slovenščina', region: 'Slovenia' },
  'sv-SE': { native: 'Svenska', region: 'Sweden' },
  'th-TH': { native: 'ไทย', region: 'Thailand' },
  'uk-UA': { native: 'Українська', region: 'Ukraine' },
  ur: { native: 'اردو', region: 'Pakistan' },
  'vi-VN': { native: 'Tiếng Việt', region: 'Vietnam' },
  zh: { native: '中文', region: 'China' },
  'zh-CN': { native: '中文', region: 'China (Simplified)' },
} as const satisfies Record<AppLocale, { native: string; region: string }>;
